export const BEFORVALUEACTION = Symbol('beforValueActionContext')
export const AFTERVALUEACTION = Symbol('afterValueActionContext')
export const BUTTONACTION = Symbol('buttonActionContext')
export const BUTTONGROUP = Symbol('buttonGroupContext')
export const BUTTONSHOW = Symbol('buttonShowContext')
